// Entscheidungen im Regierungsalltag: kleinere Ereignisse, auf die die Regierung reagieren muss.
import { DECISIONS } from '../content/decisions';
import { DECISIONS3 } from '../content/decisions3';
import { DECISIONS4 } from '../content/decisions4';
import { admOn, admMode, panMult } from './adm';
import { since } from './version';
import { polarEffect } from './polar';
import { OUTLETS } from '../content/parties';
import { on } from '../content/settings';
import { blocker } from './budget';
import { applyEff } from './economy';
import { toast } from './govern';
import { press } from './media';
import { rnd } from './rng';
import { PN, score } from './rules';
import { S, log } from './state';
import { clamp } from './util';

/** Entscheidungen der laufenden Partie (ab Version 3 zusätzlich gesellschaftspolitische). */
const pool4 = (): any[] => (admOn() ? DECISIONS4.filter((d) => !d.need || d.need(S.adm, admMode())) : []);
const pool3 = (): any[] => (since(3) ? [...DECISIONS, ...DECISIONS3, ...pool4()] : DECISIONS);
export const decisionById = (id: string): any => DECISIONS.find((d) => d.id === id) ?? DECISIONS3.find((d) => d.id === id) ?? DECISIONS4.find((d) => d.id === id);

/** Regelversion 4: Wirkung einer Entscheidung auf die Verwaltung. Verluste wiegen je nach Schwierigkeit schwerer. */
function admEff(x: any) {
  if (!x || !admOn()) return;
  const a = S.adm, k = (v: number) => (v < 0 ? v * panMult() : v);
  if (x.dig) a.dig = clamp(a.dig + k(x.dig), 0, 100);
  if (x.pipe) a.pipe = Math.max(0, a.pipe + k(x.pipe));
  if (x.pens) a.pens += x.pens;
  if (x.pay) { a.pay = true; log('Besoldungsreform: Der Bund zahlt mehr, offene Stellen lassen sich leichter besetzen.'); }
}

/** Monatlich: Mit etwas Glück (oder Pech) steht eine Entscheidung an. Nicht gleichzeitig mit einer Krise. */
export function decisionTick(): boolean {
  if (!on('events') || S.crisis || S.dec || blocker()) return false;
  if (rnd() >= .045) return false;
  const recent = S.decHist || [], pool = pool3().filter((d) => !recent.slice(-8).includes(d.id));
  if (!pool.length) return false;
  const d = pool[Math.floor(rnd() * pool.length)];
  S.dec = { id: d.id, m: S.m }; (S.decHist = recent).push(d.id);
  log(`Entscheidung gefragt: ${d.t}. ${d.s}`); toast(`Entscheidung: ${d.t}`, '');
  return true;
}

/** Option i wählen: Wirkungen anwenden, Koalitionspartner und Basis reagieren auf die Haltung. */
export function decide(i: number) {
  const D = S.dec && decisionById(S.dec.id); if (!D) return;
  const o = D.o[i]; if (!o) return;
  S.dec = null;
  applyEff(o.e);
  admEff(o.adm);
  const pos = o.pos || {};
  if (Object.keys(pos).length) {
    S.partners.forEach((p: string) => { const d = (score(p, pos) - .55) * 8; S.coal = clamp(S.coal + d, 0, 100); if (d < -2) log(`${PN(p)} ist mit eurer Entscheidung „${o.l}“ unzufrieden.`, 'bad'); });
    S.basis += (score('YOU', pos) - .55) * 1.2;
    polarEffect(pos, .7);
  }
  log(`${D.t}: Ihr entscheidet euch für „${o.l}“.`);
  press(OUTLETS[1].n, `${D.t}: Regierung setzt auf „${o.l}“`, 0);
}

/** Für den Autopiloten: die Option, die am besten zum Programm passt. */
export function bestDecision(): number {
  const D = S.dec && decisionById(S.dec.id); if (!D) return 0;
  let best = 0, bv = -1;
  D.o.forEach((o: any, i: number) => { const v = Object.keys(o.pos || {}).length ? score('YOU', o.pos) : .55; if (v > bv) { bv = v; best = i; } });
  return best;
}
